import { render, staticRenderFns } from "./ScannedDeliveriesTable.vue?vue&type=template&id=0d6b5318&scoped=true&lang=pug"
import script from "./ScannedDeliveriesTable.vue?vue&type=script&lang=js"
export * from "./ScannedDeliveriesTable.vue?vue&type=script&lang=js"
import style0 from "./ScannedDeliveriesTable.vue?vue&type=style&index=0&id=0d6b5318&prod&scoped=true&lang=css"
import style1 from "./ScannedDeliveriesTable.vue?vue&type=style&index=1&id=0d6b5318&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6b5318",
  null
  
)

export default component.exports